import { ActivityIndicator, Card, Text as PaperText } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import {
	CARD_DIMENSIONS,
	EMPTY_MESSAGES,
	ERROR_MESSAGES,
	LOADING_MESSAGES,
	SPACING,
} from "./constants";

const useStateCardStyles = () => {
	const theme = useAppTheme();
	return {
		width: "100%" as const,
		maxWidth: CARD_DIMENSIONS.maxWidth,
		borderRadius: CARD_DIMENSIONS.borderRadius,
		borderWidth: 1,
		borderColor: theme.colors.primaryContainer,
		backgroundColor: theme.colors.surface,
		overflow: "hidden" as const,
	};
};

type LoadingStateProps = {
	customLoader?: React.ReactNode;
};

export const LoadingState = ({ customLoader }: LoadingStateProps) => {
	const cardStyles = useStateCardStyles();

	if (customLoader) {
		return <>{customLoader}</>;
	}

	return (
		<Card mode="outlined" style={cardStyles}>
			<Card.Content>
				<Box gap={12} alignItems="center" padding={SPACING.card}>
					<ActivityIndicator size="large" />
					<PaperText variant="bodyMedium">{LOADING_MESSAGES.default}</PaperText>
				</Box>
			</Card.Content>
		</Card>
	);
};

type ErrorStateProps = {
	customErrorComponent?: React.ReactNode;
};

export const ErrorState = ({ customErrorComponent }: ErrorStateProps) => {
	const theme = useAppTheme();
	const cardStyles = useStateCardStyles();

	if (customErrorComponent) {
		return <>{customErrorComponent}</>;
	}

	return (
		<Card mode="outlined" style={cardStyles}>
			<Card.Content>
				<Box padding={SPACING.card}>
					<PaperText variant="bodyMedium" style={{ color: theme.colors.error }}>
						{ERROR_MESSAGES.networkError}
					</PaperText>
				</Box>
			</Card.Content>
		</Card>
	);
};

type EmptyStateProps = {
	customEmptyStateComponent?: React.ReactNode;
};

export const EmptyState = ({ customEmptyStateComponent }: EmptyStateProps) => {
	const cardStyles = useStateCardStyles();

	if (customEmptyStateComponent) {
		return <>{customEmptyStateComponent}</>;
	}

	return (
		<Card mode="outlined" style={cardStyles}>
			<Card.Content>
				<Box padding={SPACING.card}>
					<PaperText variant="bodyMedium">{EMPTY_MESSAGES.noData}</PaperText>
				</Box>
			</Card.Content>
		</Card>
	);
};
